// src/components/property/PropertySubmenu.tsx
/**
 * PropertySubmenu
 *
 * Submenu for the Real Estate section with Draft, Ready, and + New links.
 */

import { memo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FileText, CheckCircle, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

const PropertySubmenu = () => {
  const location = useLocation();

  const menuItems = [
    {
      path: '/property/draft',
      label: 'Draft',
      icon: FileText,
    },
    {
      path: '/property/ready',
      label: 'Ready',
      icon: CheckCircle,
    },
    {
      path: '/property/video-settings',
      label: 'Video Settings',
      icon: Settings,
    },
  ];

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="px-4 py-4 border-b border-gray-200 dark:border-gray-800">
        <h2 className="text-sm font-semibold text-gray-900 dark:text-gray-100">Real Estate</h2>
      </div>

      {/* Navigation */}
      <nav className="flex-1 py-2">
        {menuItems.map(item => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex items-center gap-3 px-4 py-2.5 text-sm transition-colors',
                isActive
                  ? 'bg-blue-50 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400 font-medium'
                  : 'text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-800/50'
              )}
            >
              <Icon className="h-4 w-4" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export const PropertySubmenuMemo = memo(PropertySubmenu);
